// extracted by mini-css-extract-plugin
export default {"subordinates":"Subordinates_subordinates__GEIR7","content":"Subordinates_content__9Gspt"};